// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"50b26f60","732":"7f33f77a","977":"cd3f15ac"}[chunkId] + ".chunk.js";
};